import React, { useState } from 'react'
import HeaderThree from 'components/Headers/HeaderThree'
import Layout from 'UserApp/components/Layout'
import Text from 'components/Text'
import Button from 'components/Forms/Button'
import alarmClockIcon from './dialy_check_alaram.png'
import style from './style.module.scss'
import SOSButton from 'UserApp/components/Alarm/SOSButton'
import { Link } from 'react-router-dom'

function AlarmReadyScreen(props) {
  const { alarms } = props

  const [expandedAlarms, setExpandedAlarms] = useState({})
  const toggleReadMore = (alarmId) => {
    setExpandedAlarms(prev => ({
      ...prev,
      [alarmId]: !prev[alarmId]
    }))
  }

  const maxLength = 35

  const renderActionButtons = (alarm) => (
    <div className={style.mobileActions}>
      {/* <button className={style.mobileActionButton}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round">
          <polyline points="17 1 21 5 17 9" />
          <path d="M3 11V9a4 4 0 0 1 4-4h14" />
          <polyline points="7 23 3 19 7 15" />
          <path d="M21 13v2a4 4 0 0 1-4 4H3" />
        </svg>
      </button> */}
      <button className={style.mobileActionButton} onClick={() => {
        props.history.push(`/alarm/update/${alarm.id}`)
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
        </svg>
      </button>
      <button className={style.mobileActionButton} onClick={() => {
        props.history.push(`/alarm/delete/${alarm.id}`)
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round">
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6l-1 14H6L5 6" />
          <path d="M10 11v6" />
          <path d="M14 11v6" />
          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
        </svg>
      </button>
    </div>
  )

  const renderMobileView = (alarm, index) => {
    const shouldTruncate = alarm.locationDetails && alarm.locationDetails.length > maxLength
    const isExpanded = expandedAlarms[index]
    const displayText = isExpanded || !shouldTruncate
      ? alarm.locationDetails
      : alarm.locationDetails.slice(0, maxLength) + '...'

    return (
      <div className={style.mobileView} key={index}>
        <div className={style.mobileCardBody}>
          <div className={style.mobileDate}>
            <span className={style.mobileLabel}>Date:</span>
            <div className={style.mobileCardHeader}>
              <span className={style.mobileValue}>{alarm.startTime.toLocaleDateString()}</span>
              {renderActionButtons(alarm)}
            </div>
          </div>

          <div className={style.mobileTime}>
            <span className={style.mobileLabel}>Time:</span>
            <span className={style.mobileValue}>{alarm.startTime.toLocaleTimeString()}</span>
          </div>

          <div className={style.mobileRow}>
            <span className={style.mobileLabel}>Pre-Alarm Reminder:</span>
            <span className={style.mobileValue}>
              {alarm.preAlarmReminderMinutes === 0 ? 'Not Pre-Alarm Reminder Set' : `${alarm.preAlarmReminderMinutes} Minutes`}
            </span>
          </div>
          <div className={style.mobileRow}>
            <span className={style.mobileLabel}>Emergency Contact Delay:</span>
            <span className={style.mobileValue}>
              {alarm.emergencyNotificationDelayMinutes === 0 ? 'No Delay' : `${alarm.emergencyNotificationDelayMinutes} Minutes`}
            </span>
          </div>
          <div className={style.mobileRow}>
            <span className={style.mobileLabel}>Location & Activity Details:</span>
            <span className={`${style.mobileValue} ${style.expandableText}`}>
              {displayText}
              {shouldTruncate && (
                <button
                  onClick={() => toggleReadMore(index)}
                  className={style.readMore}
                  type="button"
                >
                  {isExpanded ? 'Read Less' : 'Read More'}
                </button>
              )}
            </span>
          </div>
        </div>
        <hr />
      </div>
    )
  }

  return (
    <Layout title='Alarms' customButton={() => <SOSButton />}>
      <HeaderThree className={style.subHeader}>
        Daily Check-In Alarm
      </HeaderThree>
      <Text className={style.text}>
        Pet parent must reside at the same location as pet(s) for geo-fencing and emergency alarm notifications to work.
      </Text>
      {
        alarms?.length > 0 ? <HeaderThree className={style.scheduleHeader}>
          Daily Check-In Alarm Schedule
          <img src={alarmClockIcon} alt="Alarm Clock" />
        </HeaderThree> : <Link className={style.link} to='/alarm/daily-check-in-alarms'>
          Learn how daily check-in alarms work
        </Link>
      }

      <div className={style.mobileView}>
        {alarms?.map((alarm, index) => renderMobileView(alarm, index))}
      </div>

      <div className={style.desktopView}>
        <table className={style.alarmTable}>
          <thead>
            <tr>
              <th className={style.label}>Date</th>
              <th className={style.label}>Alarm Time</th>
              <th className={style.label}>Pre-Alarm Reminder</th>
              <th className={style.label}>Emergency Contact Delay</th>
              <th className={style.label}>Location & Activity Details</th>
              <th className={style.label}></th>
            </tr>
          </thead>
          <tbody>
            {alarms?.map((alarm, index) => {
              const shouldTruncate = alarm.locationDetails && alarm.locationDetails.length > maxLength
              const isExpanded = expandedAlarms[index]
              const displayText = isExpanded || !shouldTruncate
                ? alarm.locationDetails
                : alarm.locationDetails.slice(0, maxLength) + '...'

              return (
                <tr key={index}>
                  <td className={style.value}>{alarm.startTime.toLocaleDateString()}</td>
                  <td className={style.value}>{alarm.startTime.toLocaleTimeString()}</td>
                  <td className={style.value}>
                    {alarm.preAlarmReminderMinutes === 0 ? 'Not Pre-Alarm Reminder Set' : `${alarm.preAlarmReminderMinutes} Minutes`}
                  </td>
                  <td className={style.value}>
                    {alarm.emergencyNotificationDelayMinutes === 0 ? 'No Delay' : `${alarm.emergencyNotificationDelayMinutes} Minutes`}
                  </td>
                  <td className={`${style.value} ${style.expandableText}`}>
                    <p>{displayText}
                    {shouldTruncate && (
                      <button
                        onClick={() => toggleReadMore(index)}
                        className={style.readMore}
                        type="button"
                      >
                        {isExpanded ? 'Read Less' : 'Read More'}
                      </button>
                    )}</p>
                  </td>
                  <td className={style.actions}>
                    {renderActionButtons(alarm)}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <Button type='button' small onClick={() => {
        props.history.push('/alarm/add')
      }}>
        + Add Alarm
      </Button>
      <Text className={style.textAutomatic}>
        *Automatic based on location alarms Feature only available through the Pet Notify mobile app
      </Text>
    </Layout>
  )
}

export default AlarmReadyScreen